module.exports = __webpack_public_path__ + "static/media/play.639964df.svg";